import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { api } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import { CalendarDays, ArrowRight } from "lucide-react";

const FALLBACK = "https://images.unsplash.com/photo-1631679706909-1844bbd07221?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F6F2]">
      <Header />
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-12">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#E3F3ED] text-[#1A365D] text-sm font-medium mb-4">CareBed Resources</span>
        <h1 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-[#1C211F] mb-3">Senior care guides & insights</h1>
        <p className="text-lg text-[#4A534E] max-w-2xl mb-10">Advice for families and discharge planners navigating assisted living, skilled nursing, and memory care in Colorado.</p>

        {loading ? (
          <div className="grid md:grid-cols-3 gap-6">{Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-80 rounded-2xl" />)}</div>
        ) : posts.length === 0 ? (
          <div className="text-center py-20 text-[#5C6660]">No articles yet. Check back soon.</div>
        ) : (
          <div className="grid md:grid-cols-3 gap-6" data-testid="blog-grid">
            {posts.map((p) => (
              <Link key={p.post_id} to={`/blog/${p.slug}`} data-testid="blog-card"
                className="group bg-white border border-[#E8E6DF] rounded-2xl overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <div className="h-44 overflow-hidden">
                  <img src={p.cover_image || FALLBACK} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-1.5 text-xs text-[#5C6660] mb-2"><CalendarDays className="h-3.5 w-3.5" />{new Date(p.created_at).toLocaleDateString()}</div>
                  <h2 className="font-heading text-xl font-medium text-[#1C211F] leading-snug mb-2">{p.title}</h2>
                  <p className="text-sm text-[#4A534E] line-clamp-2">{p.excerpt}</p>
                  <span className="inline-flex items-center gap-1 text-sm text-[#0077B6] font-medium mt-3">Read more <ArrowRight className="h-3.5 w-3.5" /></span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
